import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Box } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { Form, Field } from 'react-final-form'

import { DatePicker, TimePicker } from 'src/components/Form'
import { Layout, Container, Content, PageTitle } from 'src/components/Layout'
import Button from 'src/components/Button/Button'

import styles from './TimeAndDate.module.less'

import intlMessages from './translations'

class TimeAndDate extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  state = {
    inputTimeType: 'text',
  }

  handleSubmit = values => {
    this.props.setDateAndTime(values)
    this.props.history.push('/claims/form')
  }

  validateFormFields = values => {
    const { intl } = this.props

    const errors = {}
    if (!values.date) {
      errors.date = intl.formatMessage(intlMessages.timeAndDateValidationDate)
    }
    if (!values.time) {
      errors.time = intl.formatMessage(intlMessages.timeAndDateValidationTime)
    }
    return errors
  }

  render() {
    const { intl } = this.props
    return (
      <Layout className='m-claims-time-and-date'>
        <Content>
          <PageTitle
            title={intl.formatMessage(intlMessages.timeAndDateHeader)}
            subtitle={intl.formatMessage(intlMessages.claimsFillOutTheForm)}
          />
          <Container padder className='global-centered-desktop-content'>
            <Form
              validate={this.validateFormFields}
              onSubmit={this.handleSubmit}
              render={({ handleSubmit }) => (
                <form className={styles.form} onSubmit={handleSubmit}>
                  <Box mt={'20px'} mb={'10px'}>
                    <Field
                      name='date'
                      initialValue={this.props.date}
                      placeholder={intl.formatMessage(intlMessages.timeAndDatePlaceholderDate)}
                      component={DatePicker}
                    />
                  </Box>

                  <Box mb={'30px'}>
                    <Field
                      name='time'
                      initialValue={this.props.time}
                      placeholder={intl.formatMessage(intlMessages.timeAndDatePlaceholderTime)}
                      component={TimePicker}
                    />
                  </Box>

                  <Button
                    isFullWidth
                    id='app.quote.submit'
                    type='primary'
                    htmlType='submit'
                    data-qa='button-submit-quote'
                  >
                    <FormattedMessage id='app.timeAndDate.submit' defaultMessage='Submit' />
                  </Button>
                </form>
              )}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default injectIntl(TimeAndDate)
